export const TAB_CLIN_REC = 'CLIN_REC'
export const TAB_MY_CLIN_REC = 'MY_CLIN_REC'
export const TAB_USERS = 'USERS'
